import { ApiService } from './api.service'

const BaseUrl = '/features'

export function getList (params = {}) {
  return ApiService.get(`${BaseUrl}`, params).then(resp => resp)
}
